var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16Z",
    fill: "url(#paint0_linear_2671_32118)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2915 6.44398C10.1254 6.3425 9.90958 6.3425 9.72695 6.44398L8.43172 7.22199L7.55165 7.7294L6.25646 8.5074C6.0904 8.60888 5.87454 8.60888 5.69188 8.5074L4.66236 7.89851C4.49631 7.79703 4.38007 7.611 4.38007 7.40804V6.20719C4.38007 6.00423 4.47971 5.81818 4.66236 5.7167L5.67527 5.12474C5.84133 5.02326 6.05719 5.02326 6.23985 5.12474L7.25277 5.7167C7.41881 5.81818 7.53505 6.00423 7.53505 6.20719V6.98521L8.41512 6.46089V5.68288C8.41512 5.47992 8.31551 5.29387 8.13284 5.19239L6.25646 4.07611C6.0904 3.97463 5.87454 3.97463 5.69188 4.07611L3.78229 5.19239C3.59963 5.29387 3.5 5.47992 3.5 5.68288V7.93236C3.5 8.13531 3.59963 8.32137 3.78229 8.42285L5.69188 9.53913C5.85793 9.6406 6.0738 9.6406 6.25646 9.53913L7.55165 8.77802L8.43172 8.25371L9.72695 7.4926C9.89298 7.39112 10.1088 7.39112 10.2915 7.4926L11.3044 8.08457C11.4705 8.18605 11.5867 8.37211 11.5867 8.57506V9.77589C11.5867 9.97888 11.4871 10.1649 11.3044 10.2664L10.2915 10.8753C10.1254 10.9768 9.90958 10.9768 9.72695 10.8753L8.71403 10.2833C8.54796 10.1818 8.43172 9.99577 8.43172 9.79282V9.01482L7.55165 9.53913V10.3171C7.55165 10.5201 7.6513 10.7061 7.83393 10.8076L9.74354 11.9239C9.90958 12.0254 10.1254 12.0254 10.3081 11.9239L12.2177 10.8076C12.3838 10.7061 12.5 10.5201 12.5 10.3171V8.06765C12.5 7.86469 12.4004 7.67867 12.2177 7.57719L10.2915 6.44398Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2671_32118",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F47E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8247E5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/POLYGON.ecf987329e975dc80d4c79b8c9b61689.svg";
export { ForwardRef as ReactComponent };